// ===========================================================================
// Charge Capture — Constantes del módulo (prototipo)
//
// IMPORTANTE: Este módulo es un PROTOTIPO. Los catálogos/valores aquí están
// hardcodeados para soportar las 3 demos del documento de propuesta
// (docs/modulos/ChargeCapture/MODULO_N_CHARGE_CAPTURE.md). Cuando se
// implemente el backend, estos catálogos se moverán a endpoints reales.
// ===========================================================================

// Estados del charge a lo largo del ciclo de vida (Sección 4.1 del doc).
export const CHARGE_STATUS = {
  DRAFT:       { key: "DRAFT",        label: "Draft",            color: "default" },
  RECOMMENDED: { key: "RECOMMENDED",  label: "AI Recommended",   color: "info" },
  IN_REVIEW:   { key: "IN_REVIEW",    label: "In Review",        color: "warning" },
  APPROVED:    { key: "APPROVED",     label: "Approved",         color: "success" },
  SYNCED_AMD:  { key: "SYNCED_AMD",   label: "Synced (AMD)",     color: "primary" },
  BILLED:      { key: "BILLED",       label: "Billed",           color: "primary" },
  PAID:        { key: "PAID",         label: "Paid",             color: "success" },
  DENIED:      { key: "DENIED",       label: "Denied",           color: "error" },
  REJECTED:    { key: "REJECTED",     label: "Rejected",         color: "error" },
};

// Severidad de missing charges (Sección 3.3 del doc).
export const MISSING_SEVERITY = {
  NORMAL:   { key: "NORMAL",   label: "Normal (<24h)",      color: "default", bg: "#eceff1", text: "#37474f" },
  REVIEW:   { key: "REVIEW",   label: "Review (24–48h)",    color: "success", bg: "#e8f5e9", text: "#2e7d32" },
  WARNING:  { key: "WARNING",  label: "Warning (48–72h)",   color: "warning", bg: "#fff8e1", text: "#e65100" },
  CRITICAL: { key: "CRITICAL", label: "Critical (>72h)",    color: "error",   bg: "#ffebee", text: "#c62828" },
};

// Confianza del AI recommendation engine (Sección 3.1 del doc).
export const CONFIDENCE = {
  HIGH:   { key: "HIGH",   label: "High",   color: "success" },
  MEDIUM: { key: "MEDIUM", label: "Medium", color: "warning" },
  LOW:    { key: "LOW",    label: "Low",    color: "default" },
};

// Resultado de cada validación (Sección 3.2 del doc).
export const VALIDATION_RESULT = {
  PASS:    { key: "PASS",    label: "Pass",    color: "success" },
  WARNING: { key: "WARNING", label: "Warning", color: "warning" },
  FAIL:    { key: "FAIL",    label: "Fail",    color: "error" },
};

// Tabs principales del módulo.
export const CHARGE_CAPTURE_TABS = {
  QUEUE:   "queue",
  MISSING: "missing",
  METRICS: "metrics",
};

// Flag global de habilitación (lee la env var REACT_APP_ENABLE_CHARGE_CAPTURE).
// Cuando es `true`, el módulo se monta en el sidebar y los routes responden.
// En producción la variable no está definida → el módulo permanece oculto.
export const CHARGE_CAPTURE_ENABLED =
  process.env.REACT_APP_ENABLE_CHARGE_CAPTURE === "true";
